import React from 'react'
import Question from 'components/Question'
import questionData from 'data/questions.json'

interface QuestionScreenProps {
  currentStep: number
}

// TODO: use static query
const QuestionScreen: React.FC<QuestionScreenProps> = ({ currentStep }) => {
  const { question, answers } = questionData.find(
    (question) => question.step === currentStep,
  )
  return <Question question={question} answers={answers} />
}

export default QuestionScreen
